<script setup>
import { useGlobalStore } from '@stores/global'
import { Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { ref } from 'vue'

defineProps(['dark'])

const breakpoints = ref({
	0: { slidesPerView: 1 },
	770: { slidesPerView: 2 },
	1550: { slidesPerView: 3 },
})

const global = useGlobalStore()
</script>
<template>
	<section :class="['container overflow-hidden', dark && 'bg-bgSecondary']">
		<Swiper :breakpoints="breakpoints" class="flex" :modules="[Navigation, Pagination]" :navigation="true" :pagination="true">
			<SwiperSlide v-for="social in global.socials" :key="social.avatar_url" class="p-2">
				<a :href="social.link" :class="['social-item-shadow text-default relative flex w-full items-center justify-between gap-5 rounded-2xl px-12 py-7 transition-all duration-500 lg:min-w-[320px]', dark ? 'bg-border' : 'bg-bgSecondary']" target="_blank">
					<h4><i :class="social.platform.icon" /></h4>
					<div class="label-medium flex flex-col gap-1">
						<!-- <span class="font-bold" v-if="social.formatted_reach">
							{{ social.formatted_reach }}
						</span> -->
						<span class="font-bold text-sm text-primaryMd">{{ social.platform.name }}</span>
					</div>
				</a>
			</SwiperSlide>
		</Swiper>
	</section>
</template>
